/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from "@compiled/react";

import { N100 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";

import {
    type ValidationStatus,
    ValidationStatusIcon
} from "./validation-status-icon";

const siteNameSuffixContainerStyles = css({
    paddingInlineEnd: token("space.100", "8px"),
    display: "flex",
    fontSize: "16px",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "auto",
    color: token("color.text.subtle", N100),
    fontWeight: token("font.weight.regular")
});

const siteNameSuffixLabelStyles = css({
    fontSize: "14px !important",
    whiteSpace: "nowrap"
});

export interface SiteNameSuffixProps {
    readonly siteNameSuffixLabel?: string;
    readonly validationStatus?: ValidationStatus;
}

export const SiteNameSuffix = ({
    siteNameSuffixLabel,
    validationStatus
}: SiteNameSuffixProps) => {
    return (
        <div css={siteNameSuffixContainerStyles}>
            <span css={siteNameSuffixLabelStyles}>{siteNameSuffixLabel}</span>
            <ValidationStatusIcon status={validationStatus} />
        </div>
    );
};
